import { Link } from 'react-router-dom';
import { FileText, Home, ChevronRight } from 'lucide-react';

const TermsPage = () => {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-white pt-20">
      {/* Breadcrumb */}
      <div className="bg-slate-100 border-b border-slate-200">
        <div className="container-custom py-3">
          <nav className="flex items-center gap-2 text-sm" aria-label="Breadcrumb">
            <Link to="/" className="flex items-center gap-1 text-slate-500 hover:text-blue-600 transition-colors">
              <Home className="w-4 h-4" />
              <span>Kryefaqja</span>
            </Link>
            <ChevronRight className="w-4 h-4 text-slate-400" />
            <span className="text-slate-900 font-medium">Kushtet dhe Rregullat</span>
          </nav>
        </div>
      </div>
      
      {/* Header */}
      <section className="py-12 bg-slate-50 border-b border-slate-200">
        <div className="container-custom">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center">
              <FileText className="w-7 h-7 text-blue-600" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-slate-900 font-['Inter_Tight']">
                Kushtet dhe Rregullat e Përdorimit
              </h1>
              <p className="text-slate-500 mt-1">Përditësimi i fundit: 13 Shkurt 2026</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-12">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-slate max-w-none">
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">1. Informacion mbi Operatorin</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Platforma AlbMove operohet nga <strong>C.S.M. Sh.p.k.</strong>, shoqëri me përgjegjësi të kufizuar, e regjistruar në Qendrën Kombëtare të Biznesit në Republikën e Shqipërisë me:
            </p>
            <ul className="list-none space-y-2 mb-6 bg-slate-50 rounded-xl p-6">
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">NIPT:</span> <span className="text-slate-600">M21612019M</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Datë regjistrimi:</span> <span className="text-slate-600">12/04/2022</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Administrator:</span> <span className="text-slate-600">Altin Shamku</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Zyrë qendrore:</span> <span className="text-slate-600">Rruga Muçaj, Godina 1, 1032, Vorë, Tiranë, Shqipëri</span></li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">
              Në vijim referuar si "Shoqëria" ose "AlbMove".
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Këto Kushte përbëjnë marrëveshje kontraktore ndërmjet Përdoruesit dhe C.S.M. Sh.p.k.
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">2. Përkufizime</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Për qëllime të këtyre Kushteve:</p>
            <ul className="space-y-3 mb-6">
              <li className="text-slate-600"><strong className="text-slate-800">"Platforma"</strong> përfshin faqen e internetit, aplikacionin mobile, API-të, backend-in, sistemin e menaxhimit, si dhe rrjetin e stacioneve të karikimit të integruara përmes OCPP.</li>
              <li className="text-slate-600"><strong className="text-slate-800">"Përdorues"</strong> është çdo person fizik ose juridik që regjistrohet ose përdor shërbimet.</li>
              <li className="text-slate-600"><strong className="text-slate-800">"Llogari"</strong> është profili personal i krijuar në Platformë.</li>
              <li className="text-slate-600"><strong className="text-slate-800">"Portofol" ose "Wallet"</strong> është sistemi elektronik i krediteve ku 1 Credit = 1 Lek (ALL).</li>
              <li className="text-slate-600"><strong className="text-slate-800">"Stacion Karikimi"</strong> është çdo pajisje karikimi e integruar në sistem.</li>
              <li className="text-slate-600"><strong className="text-slate-800">"Sesion Karikimi"</strong> është periudha nga aktivizimi deri në përfundimin e karikimit.</li>
              <li className="text-slate-600"><strong className="text-slate-800">"Operator"</strong> është subjekti që zotëron ose administron një stacion të lidhur me sistemin AlbMove.</li>
              <li className="text-slate-600"><strong className="text-slate-800">"OCPP"</strong> është protokolli Open Charge Point Protocol.</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">3. Pranimi i Kushteve</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Duke përdorur Platformën, Përdoruesi:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Deklaron se ka kapacitet juridik sipas Kodit Civil të Republikës së Shqipërisë;</li>
              <li className="text-slate-600">Pranon plotësisht këto Kushte;</li>
              <li className="text-slate-600">Pajtohet që këto Kushte kanë vlerë kontraktore detyruese.</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              Shoqëria rezervon të drejtën për të ndryshuar këto Kushte në çdo kohë, në përputhje me legjislacionin shqiptar për mbrojtjen e konsumatorit (Ligji Nr. 9902, datë 17.04.2008 "Për mbrojtjen e konsumatorëve", i ndryshuar).
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">4. Krijimi dhe Verifikimi i Llogarisë</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.1 Llogaritë Individuale</h3>
            <p className="text-slate-600 leading-relaxed mb-4">Përdoruesi duhet të japë të dhëna të sakta dhe të plota, në përputhje me:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Kodin Civil të Republikës së Shqipërisë</li>
              <li className="text-slate-600">Ligjin Nr. 9887/2008 "Për mbrojtjen e të dhënave personale", i ndryshuar</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">Shoqëria ka të drejtë të kërkojë dokument identifikimi për verifikim.</p>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.2 Llogaritë e Biznesit</h3>
            <p className="text-slate-600 leading-relaxed mb-4">Subjektet juridike duhet të paraqesin:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">NIPT të vlefshëm</li>
              <li className="text-slate-600">Dokumentacion regjistrimi</li>
              <li className="text-slate-600">Të dhëna të përfaqësuesit ligjor</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">Verifikimi mund të bëhet në përputhje me legjislacionin fiskal shqiptar.</p>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.3 Pezullimi</h3>
            <p className="text-slate-600 leading-relaxed mb-4">Shoqëria ka të drejtë të pezullojë ose mbyllë llogarinë në rast:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Informacioni të rremë</li>
              <li className="text-slate-600">Dyshimi për mashtrim</li>
              <li className="text-slate-600">Shkelje të këtyre Kushteve</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">5. Portofoli Dixhital dhe Pagesat</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">5.1 Sistemi i Krediteve</h3>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Portofoli funksionon si sistem parapagimi elektronik.</li>
              <li className="text-slate-600">Transaksionet përbëjnë pagesë për shërbim energjetik dhe menaxhimi.</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">5.2 Fiskalizimi</h3>
            <p className="text-slate-600 leading-relaxed mb-4">Të gjitha transaksionet fiskalizohen në përputhje me:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Ligjin Nr. 87/2019 "Për faturën dhe sistemin e monitorimit të qarkullimit"</li>
              <li className="text-slate-600">Aktet nënligjore përkatëse</li>
              <li className="text-slate-600">Udhëzimet e Administratës Tatimore</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">Fatura fiskale gjenerohet automatikisht përmes sistemit DevPOS.</p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">6. Struktura e Çmimeve</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Shoqëria aplikon çmime dinamike në përputhje me:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Kushtet e tregut</li>
              <li className="text-slate-600">Kostot e energjisë</li>
              <li className="text-slate-600">Politikën tarifore të Operatorit</li>
            </ul>
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
              <p className="text-slate-700 font-semibold mb-2">Pricing Snapshot</p>
              <p className="text-slate-600">Çmimi i shfaqur në momentin e fillimit të sesionit përbën ofertë të pranuar nga Përdoruesi dhe mbetet i pandryshueshëm për atë sesion.</p>
            </div>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">7. Përgjegjësia për Përdorimin e Stacioneve</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Përdoruesi është përgjegjës për:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Përdorim të sigurt të pajisjeve</li>
              <li className="text-slate-600">Respektimin e udhëzimeve teknike</li>
              <li className="text-slate-600">Respektimin e rregullave të sigurisë</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">Shoqëria nuk mban përgjegjësi për dëme që burojnë nga:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Defekte të automjetit</li>
              <li className="text-slate-600">Instalime jo të përshtatshme</li>
              <li className="text-slate-600">Përdorim i papërshtatshëm</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">8. Dështime Teknike</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Në rast ndërprerjeje teknike:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Faturimi bëhet vetëm për energjinë e konsumuar</li>
              <li className="text-slate-600">Nuk aplikohen tarifa të padrejta</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">Shoqëria nuk mban përgjegjësi për ndërprerje të shkaktuara nga:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Operatori i rrjetit elektrik</li>
              <li className="text-slate-600">Forca madhore</li>
              <li className="text-slate-600">Sulme kibernetike</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">9. Rimbursimet</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Rimbursimi shqyrtohet në përputhje me:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Ligjin për mbrojtjen e konsumatorit</li>
              <li className="text-slate-600">Parimet e proporcionalitetit</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">Vendimi merret brenda 5 ditëve pune.</p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">10. Kufizimi i Përgjegjësisë</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Në përputhje me Kodin Civil:</p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Shoqëria përgjigjet vetëm për dëme të drejtpërdrejta të provuara.</li>
              <li className="text-slate-600">Përgjegjësia maksimale kufizohet në shumën e paguar nga Përdoruesi gjatë 12 muajve të fundit.</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">11. Forca Madhore</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Në përputhje me nenet përkatëse të Kodit Civil, Shoqëria përjashtohet nga përgjegjësia në rast force madhore.
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">12. Mbrojtja e të Dhënave dhe GDPR</h2>
            <p className="text-slate-600 leading-relaxed mb-4">AlbMove përpunon të dhëna personale në përputhje me:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Ligjin Nr. 9887/2008 "Për mbrojtjen e të dhënave personale"</li>
              <li className="text-slate-600">Rregulloren (BE) 2016/679 (GDPR), kur aplikohet</li>
              <li className="text-slate-600">Parimet e ligjshmërisë, proporcionalitetit dhe minimizimit</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">Përdoruesi ka të drejtë për:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Akses</li>
              <li className="text-slate-600">Korrigjim</li>
              <li className="text-slate-600">Fshirje</li>
              <li className="text-slate-600">Kufizim përpunimi</li>
              <li className="text-slate-600">Kundërshtim</li>
              <li className="text-slate-600">Portabilitet të të dhënave</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              Kërkesat drejtohen në: <a href="mailto:support@albmove.al" className="text-blue-600 hover:underline">support@albmove.al</a>
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">13. Juridiksioni</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Këto Kushte rregullohen nga ligjet e Republikës së Shqipërisë.</p>
            <p className="text-slate-600 leading-relaxed mb-6">Çdo mosmarrëveshje i nënshtrohet juridiksionit ekskluziv të Gjykatave të Tiranës.</p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">14. Dispozita Përfundimtare</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Nëse ndonjë dispozitë shpallet e pavlefshme, pjesa tjetër mbetet në fuqi.</p>
            <p className="text-slate-600 leading-relaxed mb-8">Këto Kushte përbëjnë marrëveshjen e plotë ndërmjet Përdoruesit dhe C.S.M. Sh.p.k.</p>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
